import { SxProps, Theme } from "@mui/material/styles";

export function wrapper(theme: Theme): SxProps<Theme> {
    return {
        backgroundColor: "white",
        zIndex: 5,
        my: 2,
        borderRadius: "15px",
        border: "1px solid black",
        maxWidth: "1100px",
        backgrounColor: "white",
        width: "100%"
    };
}

export function expirationPeriodCardWrapper(theme: Theme): SxProps<Theme> {
    return {
        display: "inline-flex",
        flexWrap: "wrap",
        gap: "25px",
        width: "100%",
        justifyContent: "center"
    };
}

export function statusTitle(theme: Theme): SxProps<Theme> {
    return {
        fontSize: "20px",
        mb: "5px",
        textAlign: "center"
    };
}

export function statusFormControl(theme: Theme): SxProps<Theme> {
    return {
        width: "200px"
    };
}
